import React from "react";
import styled from "styled-components";
import debounce from "lodash/debounce";

import { color } from "./../../style/Variables.js";

const SVG = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  fill: ${color.ice_blue};
  stroke: blue;
  stroke-width: 0.01;
`;

export default class Background extends React.Component {
  state = {
    points: [[0, 0.1], [1, 0.5], [1, 1], [0, 1]],
    width: 0,
    height: 0,
  };
  onResize = debounce(() => {
    this.updateDimension();
  }, 150);
  onScroll = debounce(
    () => {
      this.updateDimension();
    },
    500,
    true
  );
  toD = (str, v, index) => {
    const x = v[0] * this.state.width;
    const y = v[1] * this.state.height;
    str += `${index === 0 ? "M" : "L"}${x},${y}`;
    return str;
  };
  getD = () => {
    const { width, height } = this.state;
    const y = 320;
    let str = `M${0},${y}`;
    str += `L${width},${y + Math.round(width * 0.5)}`;
    str += `L${width},${height}`;
    str += `L${0},${height}`;
    str += `L${0},${0}`;
    return str;
  };
  updateDimension() {
    if (this.props.$el) {
      const width = this.props.$el.offsetWidth;
      const height = this.props.$el.offsetHeight;
      if (this.state.width !== width || this.state.height !== height) {
        this.setState({
          width: this.props.$el.offsetWidth,
          height: this.props.$el.offsetHeight,
        });
      }
    }
  }
  componentDidMount() {
    window.addEventListener("resize", this.onResize, { passive: true });
    setTimeout(() => {
      this.updateDimension();
    }, 1000);
    window.addEventListener("scroll", this.onScroll, { passive: true });
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
    window.removeEventListener("scroll", this.onScroll);
  }
  componentDidUpdate(pp) {
    if (pp.$el !== this.props.$el) {
      this.updateDimension();
    }
  }
  render() {
    return (
      <SVG viewBox={`0 0 ${this.state.width} ${this.state.height}`}>
        <path d={this.getD()} />
      </SVG>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Home/SectionPOD/Background.js